export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NAVIGATE_PREVIEW_SCREEN"] = "NAVIGATE_PREVIEW_SCREEN";
    ACTION["DOWNLOAD_COLLATERAL"] = "DOWNLOAD_COLLATERAL";
    ACTION["UPLOAD_IMAGE_TO_S3"] = "UPLOAD_IMAGE_TO_S3";
})(ACTION || (ACTION = {}));
